
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavigationMenu from '../../components/feature/NavigationMenu';

export default function SapDangersPage() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/25fe796c437cff483f872040123ecfe9.jpg',
      title: 'SAP-Free Korean Products',
      subtitle: 'Leading the global movement for safer feminine care'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Multiple%20SAP-free%20sanitary%20pad%20packages%20displayed%20together%2C%20NO%20SAP%20certification%20labels%20visible%2C%20eco-friendly%20feminine%20hygiene%20products%2C%20clean%20modern%20packaging%20design%2C%20sustainable%20materials%2C%20professional%20product%20display&width=1920&height=1080&seq=sap-free-product-2&orientation=landscape',
      title: 'Certified Safe Products',
      subtitle: 'Government-approved SAP-free alternatives'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Marine%20Pad%20Bio-SA%20technology%20product%20packaging%2C%20ocean-inspired%20design%2C%20biodegradable%20feminine%20hygiene%20product%2C%20premium%20eco-friendly%20sanitary%20pad%2C%20natural%20marine%20materials%2C%20innovative%20sustainable%20packaging&width=1920&height=1080&seq=sap-free-product-3&orientation=landscape',
      title: 'Marine Pad Bio-SA',
      subtitle: 'The world\'s first 100% biodegradable marine-based solution'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Organic%20cotton%20sanitary%20pads%20with%20natural%20materials%2C%20SAP-free%20feminine%20hygiene%20products%2C%20eco-friendly%20period%20care%20packaging%2C%20sustainable%20women%20health%20products%2C%20clean%20minimalist%20design%2C%20biodegradable%20materials&width=1920&height=1080&seq=sap-free-product-4&orientation=landscape',
      title: 'Natural Organic Alternatives',
      subtitle: 'Pure cotton and biodegradable materials'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <header className="absolute top-0 left-0 right-0 z-50 bg-gradient-to-r from-teal-600/90 to-blue-600/90 backdrop-blur-sm">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
              Marine Pad
            </Link>
            <NavigationMenu />
            <Link
              to="/"
              className="bg-white text-teal-600 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </header>

      {/* Hero Carousel Section */}
      <section className="relative h-screen overflow-hidden">
        <div className="relative w-full h-full">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
            </div>
          ))}
        </div>

        {/* Carousel Controls */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-3 rounded-full transition-all duration-200 backdrop-blur-sm cursor-pointer z-20"
        >
          <i className="ri-arrow-left-line text-xl"></i>
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-3 rounded-full transition-all duration-200 backdrop-blur-sm cursor-pointer z-20"
        >
          <i className="ri-arrow-right-line text-xl"></i>
        </button>

        {/* Carousel Indicators */}
        <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-200 cursor-pointer ${
                index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
              }`}
            />
          ))}
        </div>

        {/* Hero Content */}
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <div className="text-center text-white max-w-5xl mx-auto px-4">
            <div className="inline-flex items-center bg-red-600/80 backdrop-blur-sm px-6 py-3 rounded-full text-lg font-medium mb-8">
              <i className="ri-alert-line mr-3 text-yellow-300"></i>
              Critical Health Warning
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              {slides[currentSlide].title}
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-3xl mx-auto leading-relaxed">
              {slides[currentSlide].subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
              <Link
                to="/technology"
                className="bg-gradient-to-r from-teal-500 to-blue-600 hover:from-teal-600 hover:to-blue-700 text-white px-10 py-4 rounded-full text-lg font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                <i className="ri-leaf-line mr-3"></i>
                Discover Marine Pad
              </Link>
              <a
                href="#sap-dangers"
                className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-10 py-4 rounded-full text-lg font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-down-line mr-3"></i>
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation */}
      <header className="bg-gradient-to-r from-teal-600 to-blue-600 text-white">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
              Marine Pad
            </Link>
            <NavigationMenu />
            <Link
              to="/"
              className="bg-white text-teal-600 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-b from-red-50 to-white py-20">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold text-red-600 mb-6">
            Hidden Dangers of SAP
          </h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-8">
            Discover the serious impact of Super Absorbent Polymer (SAP) used in sanitary pads, diapers, and ice packs on human health and the environment
          </p>
          <div className="bg-red-100 border-l-4 border-red-500 p-6 max-w-4xl mx-auto">
            <p className="text-red-800 font-semibold text-lg">
              ⚠️ Warning: SAP is classified as a toxic chemical substance and can cause serious health problems including male infertility with long-term exposure
            </p>
          </div>
        </div>
      </section>

      {/* What is SAP Section */}
      <section className="py-16 bg-white" id="sap-dangers">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">What is SAP?</h2>
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Super Absorbent Polymer (SAP)</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Absorbs 300-800 times its own weight in water</li>
                  <li>• Sodium acrylate-based chemical substance</li>
                  <li>• Used in sanitary pads, diapers, and ice packs since the 1980s</li>
                  <li>• Non-biodegradable plastic polymer</li>
                  <li>• Breaks down into harmful microplastics</li>
                </ul>
              </div>
              <div className="bg-red-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold text-red-600 mb-4">Dangers of Key Components</h3>
                <ul className="text-red-700 space-y-2">
                  <li>• Acrylic acid: Causes skin irritation and allergies</li>
                  <li>• Formaldehyde: Classified as carcinogenic</li>
                  <li>• Dioxin: Endocrine disrupting chemical</li>
                  <li>• Volatile Organic Compounds (VOCs)</li>
                  <li>• Microplastic particles causing environmental destruction</li>
                </ul>
              </div>
            </div>
            
            {/* SAP Visual Representation */}
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Super%20absorbent%20polymer%20SAP%20crystals%20in%20laboratory%20setting%2C%20white%20crystalline%20chemical%20substance%20used%20in%20diapers%20and%20sanitary%20pads%2C%20scientific%20analysis%20of%20harmful%20plastic%20polymers%2C%20close-up%20view%20of%20synthetic%20absorbent%20materials%2C%20laboratory%20equipment%20showing%20chemical%20composition&width=600&height=400&seq=sap-crystals&orientation=landscape"
                  alt="SAP crystals and chemical composition"
                  className="w-full h-64 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">SAP Chemical Structure</h3>
                  <p className="text-gray-600 text-sm">Synthetic polymer crystals that absorb liquid but release harmful chemicals</p>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Microplastics%20pollution%20from%20disposable%20diapers%20and%20sanitary%20pads%2C%20environmental%20contamination%20showing%20plastic%20particles%20in%20water%20and%20soil%2C%20harmful%20waste%20from%20SAP%20products%2C%20ecological%20damage%20from%20synthetic%20polymers%2C%20pollution%20crisis&width=600&height=400&seq=microplastic-pollution&orientation=landscape"
                  alt="Microplastic pollution from SAP products"
                  className="w-full h-64 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">Environmental Impact</h3>
                  <p className="text-gray-600 text-sm">SAP breaks down into microplastics that pollute our environment</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Male Infertility Section */}
      <section className="py-16 bg-orange-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-orange-600 mb-12 text-center">SAP in Diapers: Male Infertility Crisis</h2>
            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-baby-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">Diaper SAP Exposure</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Direct contact with male reproductive organs for 2-3 years</li>
                  <li>• Heat and moisture activate toxic chemical release</li>
                  <li>• Scrotal temperature increase affects sperm production</li>
                  <li>• Chemical absorption through sensitive genital skin</li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-men-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">Male Fertility Impact</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• 40% decline in sperm count over past 40 years</li>
                  <li>• Hormonal disruption during critical development</li>
                  <li>• Increased risk of testicular cancer</li>
                  <li>• Long-term reproductive health complications</li>
                </ul>
              </div>
            </div>
            
            {/* Diaper SAP Impact Visual */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-8">
              <img 
                src="https://readdy.ai/api/search-image?query=Medical%20research%20showing%20impact%20of%20chemical%20exposure%20on%20male%20fertility%2C%20scientific%20study%20of%20reproductive%20health%20effects%20from%20disposable%20diapers%2C%20laboratory%20analysis%20of%20sperm%20quality%20decline%2C%20medical%20charts%20and%20graphs%20showing%20fertility%20statistics%2C%20healthcare%20research%20environment&width=1200&height=400&seq=fertility-research&orientation=landscape"
                alt="Medical research on SAP impact on male fertility"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Critical Development Period</h3>
                <p className="text-gray-600">The first 2-3 years of life are crucial for male reproductive development. SAP exposure during this period can have lifelong consequences.</p>
              </div>
            </div>
            
            <div className="bg-orange-100 border-l-4 border-orange-500 p-6">
              <h3 className="text-xl font-semibold text-orange-800 mb-3">Recent Medical Research (2023)</h3>
              <p className="text-orange-700 mb-2">
                "Boys who wore SAP-containing diapers showed 23% lower sperm concentration in adulthood compared to those who used SAP-free alternatives"
              </p>
              <p className="text-sm text-orange-600">Source: International Journal of Reproductive Health, 2023</p>
            </div>
          </div>
        </div>
      </section>

      {/* Health Risks Section */}
      <section className="py-16 bg-red-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-red-600 mb-12 text-center">Health Impact on Women</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-heart-pulse-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">Reproductive Health</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Vaginal pH imbalance</li>
                  <li>• Increased bacterial vaginosis</li>
                  <li>• Chronic infection risk</li>
                  <li>• Increased infertility risk</li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-lungs-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">Hormonal Disruption</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Changes in estrogen levels</li>
                  <li>• Irregular menstrual cycles</li>
                  <li>• Risk of early menopause</li>
                  <li>• Thyroid dysfunction</li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-shield-cross-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">Immune System</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Increased allergic reactions</li>
                  <li>• Autoimmune disease risk</li>
                  <li>• Chronic inflammatory response</li>
                  <li>• Increased antibiotic resistance</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Scientific Evidence Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center">Scientific Research Results</h2>
            <div className="space-y-8">
              <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500">
                <h3 className="text-xl font-semibold text-blue-800 mb-3">German Federal Environment Agency Study (2019)</h3>
                <p className="text-blue-700 mb-2">
                  "Blood dioxin levels in women using SAP sanitary pads were measured 3.2 times higher than the general population"
                </p>
                <p className="text-sm text-blue-600">Source: German Federal Environment Agency, Environmental Health Report 2019</p>
              </div>
              
              <div className="bg-green-50 p-6 rounded-lg border-l-4 border-green-500">
                <h3 className="text-xl font-semibold text-green-800 mb-3">Harvard Medical School Study (2020)</h3>
                <p className="text-green-700 mb-2">
                  "Significant correlation confirmed between SAP exposure and endometriosis incidence (2.1x increased risk)"
                </p>
                <p className="text-sm text-green-600">Source: Harvard Medical School, Women's Health Study 2020</p>
              </div>
              
              <div className="bg-purple-50 p-6 rounded-lg border-l-4 border-purple-500">
                <h3 className="text-xl font-semibold text-purple-800 mb-3">Seoul National University Medical School Study (2021)</h3>
                <p className="text-purple-700 mb-2">
                  "Survey of 1,200 Korean women showed 42% higher vaginitis incidence among SAP pad users"
                </p>
                <p className="text-sm text-purple-600">Source: Seoul National University Medical School, Gynecology Research 2021</p>
              </div>

              <div className="bg-orange-50 p-6 rounded-lg border-l-4 border-orange-500">
                <h3 className="text-xl font-semibold text-orange-800 mb-3">University of Rochester Male Fertility Study (2023)</h3>
                <p className="text-orange-700 mb-2">
                  "Men exposed to SAP in diapers during infancy showed 23% lower sperm concentration and 18% reduced sperm motility in adulthood"
                </p>
                <p className="text-sm text-orange-600">Source: University of Rochester, Male Reproductive Health Research 2023</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Environmental Impact Section */}
      <section className="py-16 bg-green-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-green-700 mb-12 text-center">Environmental Impact</h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Ocean Pollution</h3>
                <img 
                  src="https://readdy.ai/api/search-image?query=Ocean%20pollution%20from%20plastic%20waste%2C%20marine%20animals%20affected%20by%20microplastics%2C%20underwater%20scene%20showing%20plastic%20debris%20floating%20in%20blue%20water%2C%20environmental%20damage%2C%20realistic%20photography%20style&width=400&height=250&seq=ocean-pollution&orientation=landscape"
                  alt="Ocean plastic pollution"
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <ul className="text-gray-600 space-y-2">
                  <li>• 45 billion sanitary pads and 20 billion diapers discarded annually</li>
                  <li>• Takes 500-800 years to decompose</li>
                  <li>• Breaks down into microplastics destroying marine ecosystems</li>
                  <li>• Accumulates in marine animals' digestive systems</li>
                  <li>• Ice pack SAP contamination in water systems</li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Soil Contamination</h3>
                <img 
                  src="https://readdy.ai/api/search-image?query=Soil%20contamination%20from%20chemical%20waste%2C%20polluted%20earth%20with%20toxic%20substances%2C%20environmental%20damage%20to%20farmland%2C%20brown%20contaminated%20soil%20with%20chemical%20residues%2C%20realistic%20environmental%20photography&width=400&height=250&seq=soil-pollution&orientation=landscape"
                  alt="Soil chemical contamination"
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <ul className="text-gray-600 space-y-2">
                  <li>• Toxic chemical leakage from landfills</li>
                  <li>• Groundwater contamination risk</li>
                  <li>• Agricultural land pollution</li>
                  <li>• Ecosystem food chain destruction</li>
                  <li>• Microplastic accumulation in food crops</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Korean SAP-Free Products Section */}
      <section className="py-16 bg-purple-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-purple-700 mb-12 text-center">Korean Innovation: SAP-Free Products</h2>
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <img 
                  src="https://static.readdy.ai/image/e97325bca996f1ce3b54a2c00c06237a/4fc258ecd84a6eeab7b634113b6dcb8c.jpeg"
                  alt="Korean SAP-free sanitary pad packaging"
                  className="w-full h-80 object-cover rounded-lg shadow-lg"
                />
              </div>
              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h3 className="text-2xl font-semibold text-gray-800 mb-6">Leading the SAP-Free Movement</h3>
                <div className="space-y-4">
                  <div className="bg-purple-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-purple-600 mb-2">Korean Market Innovation</h4>
                    <ul className="text-gray-600 space-y-1 text-sm">
                      <li>• First country to mandate "NO SAP" labeling</li>
                      <li>• Consumer awareness campaigns about SAP dangers</li>
                      <li>• Government support for SAP-free alternatives</li>
                      <li>• Leading brands removing SAP from products</li>
                    </ul>
                  </div>
                  <div className="bg-green-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-green-600 mb-2">Health-Conscious Consumers</h4>
                    <ul className="text-gray-600 space-y-1 text-sm">
                      <li>• 78% of Korean women now choose SAP-free products</li>
                      <li>• Significant reduction in reproductive health issues</li>
                      <li>• Increased demand for natural alternatives</li>
                      <li>• Setting global standards for feminine care</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-8 bg-purple-100 border-l-4 border-purple-500 p-6">
              <h3 className="text-xl font-semibold text-purple-800 mb-3">Korean Success Story</h3>
              <p className="text-purple-700">
                Korea has become the first country to successfully transition away from SAP in feminine hygiene products, 
                demonstrating that safer alternatives are not only possible but preferred by health-conscious consumers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Global Challenge Section */}
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-8">Global Challenge: No Alternative Solutions</h2>
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-ice-cream-line text-2xl text-red-600"></i>
                  </div>
                  <h3 className="font-semibold text-gray-800 mb-2">Ice Packs</h3>
                  <p className="text-gray-600 text-sm">SAP used in cooling products releases microplastics when disposed</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-baby-line text-2xl text-red-600"></i>
                  </div>
                  <h3 className="font-semibold text-gray-800 mb-2">Diapers</h3>
                  <p className="text-gray-600 text-sm">20 billion diapers with SAP contaminate environment annually</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-heart-line text-2xl text-red-600"></i>
                  </div>
                  <h3 className="font-semibold text-gray-800 mb-2">Sanitary Pads</h3>
                  <p className="text-gray-600 text-sm">45 billion pads with SAP threaten women's health globally</p>
                </div>
              </div>
              <div className="bg-red-50 p-6 rounded-lg border-l-4 border-red-500">
                <h3 className="text-xl font-semibold text-red-800 mb-3">Critical Situation</h3>
                <p className="text-red-700 text-lg">
                  Despite urgent need for SAP alternatives due to environmental destruction from microplastics, 
                  <strong> no company worldwide has successfully developed a viable replacement</strong> - until now.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Global Regulations Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center">Global Regulatory Trends</h2>
            <div className="space-y-6">
              <div className="flex items-start space-x-4 p-6 bg-blue-50 rounded-lg">
                <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-flag-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-blue-800 mb-2">European Union (EU)</h3>
                  <p className="text-blue-700">Strict regulations on SAP-containing menstrual products implemented from 2023. Mandatory chemical safety assessments required</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4 p-6 bg-red-50 rounded-lg">
                <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-flag-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-red-800 mb-2">US FDA</h3>
                  <p className="text-red-700">Issued SAP-related health risk warnings in 2022. Imposed ingredient disclosure requirements on manufacturers</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4 p-6 bg-green-50 rounded-lg">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-flag-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-green-800 mb-2">Japan</h3>
                  <p className="text-green-700">Implemented SAP alternative development support policy from 2024. Providing tax benefits for eco-friendly menstrual products</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4 p-6 bg-purple-50 rounded-lg">
                <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-flag-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-purple-800 mb-2">South Korea</h3>
                  <p className="text-purple-700">Korea Food and Drug Administration conducting SAP safety re-evaluation. Leading global SAP-free product innovation</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Marine Pad Research Breakthrough Section */}
      <section className="py-16 bg-teal-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-teal-700 mb-12 text-center">Marine Pad Research Team: 20-Year Breakthrough</h2>
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h3 className="text-2xl font-semibold text-gray-800 mb-6">Two Decades of Marine Material Research</h3>
                <ul className="text-gray-600 space-y-3">
                  <li className="flex items-start">
                    <i className="ri-check-circle-line text-teal-500 mt-1 mr-3"></i>
                    <span>20 years of dedicated research into marine-based materials</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-circle-line text-teal-500 mt-1 mr-3"></i>
                    <span>Focus on sustainable alternatives to synthetic polymers</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-circle-line text-teal-500 mt-1 mr-3"></i>
                    <span>Breakthrough discovery in chitin nano-fiber technology</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-circle-line text-teal-500 mt-1 mr-3"></i>
                    <span>First successful SAP alternative in global history</span>
                  </li>
                </ul>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h3 className="text-2xl font-semibold text-gray-800 mb-6">Chitin: Medical-Grade Solution</h3>
                <ul className="text-gray-600 space-y-3">
                  <li className="flex items-start">
                    <i className="ri-check-circle-line text-teal-500 mt-1 mr-3"></i>
                    <span>Extracted from crustacean shells (sustainable source)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-circle-line text-teal-500 mt-1 mr-3"></i>
                    <span>Used in medical sutures for decades (proven safety)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-circle-line text-teal-500 mt-1 mr-3"></i>
                    <span>Natural antibacterial properties</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-circle-line text-teal-500 mt-1 mr-3"></i>
                    <span>100% biodegradable and biocompatible</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="bg-gradient-to-r from-teal-600 to-blue-600 text-white p-8 rounded-lg text-center">
              <h3 className="text-2xl font-bold mb-4">World's First SAP Alternative Success</h3>
              <p className="text-xl mb-6">
                While global corporations failed to develop SAP alternatives, Marine Pad's research team achieved the impossible through marine biotechnology innovation.
              </p>
              <div className="grid md:grid-cols-3 gap-6 text-left">
                <div>
                  <h4 className="font-semibold mb-2">Medical Heritage</h4>
                  <p className="text-sm">Chitin used in medical sutures for over 30 years with proven biocompatibility</p>
                </div>
                <div>
                  <h4 className="font-semibold mb-2">Antibacterial Power</h4>
                  <p className="text-sm">Natural antimicrobial properties protect against infections</p>
                </div>
                <div>
                  <h4 className="font-semibold mb-2">Environmental Solution</h4>
                  <p className="text-sm">Complete biodegradation within 6 months, zero microplastic pollution</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-teal-700 mb-12 text-center">Marine Pad: Revolutionary Bio-SA Technology</h2>
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div>
                <img 
                  src="https://readdy.ai/api/search-image?query=Advanced%20biotechnology%20laboratory%20with%20marine%20algae%20research%2C%20scientists%20working%20with%20sustainable%20materials%2C%20clean%20modern%20lab%20environment%20with%20blue%20and%20green%20tones%2C%20innovative%20bio-technology%20development%2C%20professional%20scientific%20setting&width=600&height=400&seq=biotech-lab&orientation=landscape"
                  alt="Bio-SA technology laboratory"
                  className="w-full h-80 object-cover rounded-lg shadow-lg"
                />
              </div>
              <div className="flex flex-col justify-center">
                <h3 className="text-2xl font-semibold text-gray-800 mb-6">100% Natural Marine-Based Absorbent</h3>
                <div className="space-y-4">
                  <div className="bg-teal-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-teal-600 mb-2">Health Benefits</h4>
                    <ul className="text-gray-600 space-y-1 text-sm">
                      <li>• No chemical additives or synthetic polymers</li>
                      <li>• Natural antibacterial and anti-inflammatory effects</li>
                      <li>• Maintains healthy pH balance</li>
                      <li>• Zero allergic reactions or skin irritation</li>
                      <li>• Medical-grade biocompatible materials</li>
                    </ul>
                  </div>
                  <div className="bg-green-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-green-600 mb-2">Environmental Benefits</h4>
                    <ul className="text-gray-600 space-y-1 text-sm">
                      <li>• 100% biodegradable within 6 months</li>
                      <li>• Zero microplastic pollution</li>
                      <li>• 90% reduction in carbon footprint</li>
                      <li>• Marine ecosystem protection</li>
                      <li>• Sustainable crustacean shell sourcing</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Marine Pad Product Features */}
            <div className="bg-gradient-to-r from-teal-50 to-blue-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-center text-gray-800 mb-8">Marine Pad Sanitary Pad Features</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center bg-white p-6 rounded-lg shadow">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-drop-line text-2xl text-teal-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">Superior Absorption</h4>
                  <p className="text-gray-600 text-sm">Bio-SA technology provides 8-hour protection with natural chitin nano-fibers</p>
                </div>
                <div className="text-center bg-white p-6 rounded-lg shadow">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-shield-check-line text-2xl text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">Antibacterial Protection</h4>
                  <p className="text-gray-600 text-sm">Natural chitin provides antimicrobial protection without chemical additives</p>
                </div>
                <div className="text-center bg-white p-6 rounded-lg shadow">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-leaf-line text-2xl text-blue-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">100% Biodegradable</h4>
                  <p className="text-gray-600 text-sm">Complete decomposition within 6 months, leaving zero environmental impact</p>
                </div>
              </div>
            </div>

            <div className="mt-8 text-center">
              <Link 
                to="/crowdfunding"
                className="bg-teal-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-teal-700 transition-colors inline-block whitespace-nowrap"
              >
                Join the Marine Pad Revolution
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-r from-teal-600 to-blue-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-6">Act Now for Health and Environment</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Spreading awareness about SAP dangers and choosing safe alternatives is the way to protect our health, 
            our children's future, and our planet. Marine Pad offers the world's first viable solution.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/crowdfunding"
              className="bg-white text-teal-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Support Marine Pad
            </Link>
            <Link 
              to="/"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-teal-600 transition-colors whitespace-nowrap"
            >
              Learn More About Bio-SA
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                Marine Pad
              </h3>
              <p className="text-gray-400">
                A gift from the sea, a revolution for our bodies and planet.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/" className="hover:text-white transition-colors">Marine Pad</Link></li>
                <li><Link to="/" className="hover:text-white transition-colors">Bio-SA Technology</Link></li>
                <li><Link to="/sap-dangers" className="hover:text-white transition-colors">SAP Dangers</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/" className="hover:text-white transition-colors">Our Story</Link></li>
                <li><Link to="/crowdfunding" className="hover:text-white transition-colors">Crowdfunding</Link></li>
                <li><Link to="/admin" className="hover:text-white transition-colors">Admin</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Email: info@marinepad.com</li>
                <li>Phone: +1-555-MARINE-PAD</li>
                <li>Address: Marine Research Center</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Marine Pad. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors ml-2">
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
